export const do_if = (if_result, then_process, else_process, states, inputs, events) => {
  if ( if_result ) {
    if ( then_process ) {
      const result = then_process[1](...then_process[0])
      // console.log("do_if then: ", if_result, then_process, else_process, result, states, inputs, events)
      return result
    } else {
      return null
    }
  } else {
    if ( else_process ) {
      const result = else_process[1](...else_process[0])
      // console.log("do_if else: ", if_result, then_process, else_process, result, states, inputs, events)
      return result
    } else {
      return null
    }
  }
}

export const do_for = (amount, then_process) => {
  let results = [];
  for ( let i = 0; i < amount; i++ ) {
    results.push(then_process(i))
  }
  return results
}

export const do_foreach = (...inputs) => {
  const elements = inputs[0]
  const then_process = inputs[1]
  const with_index = inputs.length >= 6 ? inputs[2] : false
  console.log("do_foreach: ", inputs)
  let results = [];
  elements.forEach((element, index)=>{
    if(with_index){
      results.push(then_process(element, index))
    }else{
      results.push(then_process(element))
    }
  }); 
  return results
}

export const do_foreach_async = async (...inputs) => {
  const elements   = inputs[0] ?? [];
  const then_proc  = inputs[1];
  const resultFunc = typeof inputs[2] === "function" ? inputs[2] : undefined;
  const with_index = inputs.length >= 7 ? inputs[3] : false

  if (typeof then_proc !== "function") {
    console.error("do_foreach_async: then_process must be a function");
    return [];
  }

  // Create tasks (sync or async)
  const tasks = [];
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];

    try {
      let val;
      if (with_index) {
        val = then_proc(element, i); // may be sync or async
      }else{
        val = then_proc(element); // may be sync or async
      }
      tasks.push(Promise.resolve(val));
    } catch (err) {
      console.error("do_foreach_async error at element", i, err);
      tasks.push(Promise.resolve(null));
    }
  }

  // Resolve all in order
  const results = await Promise.all(tasks);

  // Global callback for the full results array
  if (resultFunc) {
    try {
      resultFunc(results);
    } catch (err) {
      console.error("Error in do_foreach_async resultFunc", err);
    }
  }

  return results;
};


export const while_do = (if_process, then_process, state) => {
  while (if_process()) {
    then_process()
  }
}

export const and = (if_results, states) => {
  return if_results.reduce((accumulator, current) => !!accumulator && !!current);
}

export const or = (if_results, states) => {
  return if_results.reduce((accumulator, current) => !!accumulator || !!current);
}

export const not = (if_result, states) => {
  return !if_result;
}

export const equal = (results, states) => {
  let prev_res = results[0]
  let and_result = true
  results.forEach((current_result, i_res) => {
    if ( i_res ) {
      and_result = and_result && (current_result == prev_res);
      prev_res = current_result;
    }
  })
  return and_result;
}

export const do_switch = (...inputs) => {
  const func_input = inputs[0]
  const cases = inputs[1]
  const results = []
  cases.forEach(([test_func, do_func]) => {
    if (test_func(func_input)){
      results.push(do_func(func_input))
    }
  })
  return results
}

export const do_recursive = (...inputs) => {
  const funcArray = inputs[0] 
  const target = inputs[1]
  let route = inputs.length >= 6 ? inputs[2] : []
  const [objectFunc, arrayFunc, valueFunc] = funcArray;

  // Determine the type of the target and call the respective function
  if (Array.isArray(target)) {
    // Process with array function
    arrayFunc(target, route);

    // Recursively process each item in the array
    target.forEach((item, index) => {
      do_recursive(funcArray, item, [...route, index], {}, {}, {});
    });
  } else if (typeof target === 'object' && target !== null) {
    // Process with object function
    objectFunc(target, route);

    // Recursively process each property in the object
    Object.keys(target).forEach(key => {
      do_recursive(funcArray, target[key], [...route, key], {}, {}, {});
    });
  } else {
    // Process with value function
    valueFunc(target, route);
  }
}


export const run = (inputs_list, processes, states, inputs, events) => {
  let results = [];
 //console.log("RUN: ", processes, inputs_list)
  processes.forEach((process, i_proc) => {
    if ( process ) {
      if (inputs_list[i_proc]) {
        results.push(process(...inputs_list[i_proc]));
      } else {
        results.push(process());
      }
    } else {
      results.push(inputs_list[i_proc]);
    }
  })
 //console.log("RUN: ", processes, inputs_list, results)
  return results;
}

export const run_async = async (...inputs) => {
  const inputs_list = inputs[0] ?? [];
  const processes   = inputs[1] ?? [];
  const resultFunc  = typeof inputs[2] === 'function' ? inputs[2] : undefined;

  const tasks = processes.map((process, i_proc) => {
    if (!process) {
      // No process → just passthrough original input
      return inputs_list[i_proc];
    }

    try {
      const procInputs = inputs_list[i_proc];

      // Respect ...inputs style for each process
      if (procInputs) {
        return process(...procInputs);
      } else {
        return process();
      }
    } catch (err) {
      console.error('Error running process', i_proc, err);
      return null;
    }
  });

  // Await all results, preserving order
  const results = await Promise.all(
    tasks.map(task => Promise.resolve(task))
  );

  // Single resultFunc for the entire results array
  if (resultFunc) {
    try {
      resultFunc(results);
    } catch (err) {
      console.error('Error in runAsync resultFunc', err);
    }
  }

  return results;
};


export const chain = (...inputs) => {
  const chain_inputs = inputs[0]
  const processes = inputs[1]
  const spread = inputs.length > 5 ? inputs[2] : true
 //console.log("chain:", chain_inputs, processes)
  let current_result = chain_inputs
  processes.forEach((process, i_proc) => {
    if (Array.isArray(current_result) && spread) {
      current_result = process(...current_result)
    } else {
      current_result = process(current_result)
    }
  })
  return current_result;
}